{
  "name": "alertsense",
  "version": "2.0.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config ./src/config/proxy.conf.json",
    "start:localhost": "ng serve --proxy-config ./src/config/proxy.conf.json --configuration=localhost",
    "start:dev": "ng serve --proxy-config ./src/config/proxy.conf.dev.json --configuration=development",
    "start:staging": "ng serve --proxy-config ./src/config/proxy.conf.staging.json --configuration=staging",
    "start:prod": "ng serve --proxy-config ./src/config/proxy.conf.prod.json --configuration=production",
    "start:mock": "ng serve --configuration=mock",
    "build": "ng build",
    "build:prod": "ng build --configuration=production --verbose=true",
    "cicd": "npm run ci:install",
    "ci:install": "npm ci --verbose=true 1>angular-install.log 2>&1 && npm rebuild node-sass",
    "ci:build": "ng build --configuration=production --verbose=true 1>angular-build.log 2>&1",
    "ci:test": "ng test --browsers ChromeHeadless --source-map false --watch false --reporters junit,brief 1>angular-test.log 2>&1",
    "ci:test-lint": "ng lint --eslint-config .eslintrc.ci.json 1>angular-test-lint.log 2>&1",
    "ci:accessibility-lint": "ng lint --eslint-config .eslintrc.accessibility.json 1>angular-accessibility-lint.log 2>&1",
    "test:ci": "npm run ci:test",
    "test:debug": "ng test --source-map true --browsers ChromeDebug",
    "test:single": "ng test --source-map false --watch false",
    "test": "ng test --source-map false",
    "lint": "ng lint",
    "openapi:boxwood": "openapi-generator-cli generate -i http://localhost:5070/swagger/v1/swagger.json -g typescript-angular -o src/app/boxwood-api -c src/app/boxwood-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:directory": "openapi-generator-cli generate -i https://api-handweave.alertsense.com/swagger/Directories/swagger.json -g typescript-angular -o src/app/directory-api -c src/app/directory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:usage-local": "openapi-generator-cli generate -i http://localhost:5010/swagger/usage/swagger.json -g typescript-angular -o src/app/usage-api -c src/app/usage-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:usage": "openapi-generator-cli generate -i http://api-handweave.alertsense.com/swagger/usage/swagger.json -g typescript-angular -o src/app/usage-api -c src/app/usage-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:platform-local": "openapi-generator-cli generate -i http://localhost:5010/swagger/public/swagger.json -g typescript-angular -o src/app/platform-directory-api -c src/app/platform-directory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:platform": "openapi-generator-cli generate -i http://api-handweave.alertsense.com/swagger/public/swagger.json -g typescript-angular -o src/app/platform-directory-api -c src/app/platform-directory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:handweave": "openapi-generator-cli generate -i https://api-handweave.alertsense.com/swagger/v1/swagger.json -g typescript-angular -o src/app/handweave-api -c src/app/handweave-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:handweave-local": "openapi-generator-cli generate -i http://localhost:5010/swagger/v1/swagger.json -g typescript-angular -o src/app/handweave-api -c src/app/handweave-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:hickory": "openapi-generator-cli generate -i https://admin.alertsense.com/tamarack/swagger/swagger.json -g typescript-angular -o src/app/hickory-api -c src/app/hickory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:hickory-dev": "openapi-generator-cli generate -i https://admin.dev.alertsense.io/tamarack/swagger/swagger.json -g typescript-angular -o src/app/hickory-api -c src/app/hickory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:hickory-local": "openapi-generator-cli generate -i http://localhost:51212/tamarack/swagger/swagger.json -g typescript-angular -o src/app/hickory-api -c src/app/hickory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:hickory-json": "openapi-generator-cli generate -i ../hickory/src/App/AlertSense.Hickory.AdminWebsite/tamarack/swagger/swagger.json -g typescript-angular -o src/app/hickory-api -c src/app/hickory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:walnut": "openapi-generator-cli generate -i https://content.alertsense.com/swagger/v1/swagger.json -g typescript-angular -o src/app/walnut/walnut-api -c src/app/walnut/walnut-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:walnut-local": "openapi-generator-cli generate -i http://localhost:5062/swagger/v1/swagger.json -g typescript-angular -o src/app/walnut/walnut-api -c src/app/walnut/walnut-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:walnut-dev": "openapi-generator-cli generate -i http://content.dev.alertsense.io/swagger/v1/swagger.json -g typescript-angular -o src/app/walnut/walnut-api -c src/app/walnut/walnut-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:help": "openapi-generator-cli config-help -g typescript-angular",
    "cy": "cypress open --browser chrome --env env=dev",
    "cy:local": "cypress open --browser chrome --env env=dev --config baseUrl=http://localhost:4200",
    "cy:local-run": "cypress run --browser chrome --env env=dev --config baseUrl=http://localhost:4200",
    "cy:dev": "cypress open --browser chrome --env env=dev",
    "cy:dev-run": "cypress run --browser chrome --env env=dev",
    "cy:staging": "cypress open --browser chrome --env env=staging --config baseUrl=https://apps.staging.alertsense.io,specPattern=cypress/e2e/staging/**/*.cy.ts",
    "cy:prod": "cypress open --browser chrome --env env=prod --config baseUrl=https://apps.alertsense.com,specPattern=cypress/e2e/prod/**/*.cy.ts",
    "browserslist-update": "npx --yes update-browserslist-db@latest",
    "translate": "ts-node cli/translate/cli.ts",
    "csp:update": "ts-node cli/csp/cli.ts update",
    "csp:show": "ts-node cli/csp/cli.ts show",
    "csp:pretty": "ts-node cli/csp/cli.ts pretty"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.15",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.15",
    "@angular/compiler": "^20.3.15",
    "@angular/core": "^20.3.15",
    "@angular/forms": "^20.3.15",
    "@angular/google-maps": "^20.2.14",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.15",
    "@angular/platform-browser-dynamic": "^20.3.15",
    "@angular/platform-server": "^20.3.15",
    "@angular/router": "^20.3.15",
    "@googlemaps/js-api-loader": "^1.16.8",
    "@googlemaps/markerclusterer": "^2.5.3",
    "@jsonforms/angular": "^3.7.0",
    "@jsonforms/angular-material": "^3.7.0",
    "@jsonforms/core": "^3.7.0",
    "@openid/appauth": "^1.3.2",
    "@swimlane/ngx-charts": "^23.1.0",
    "@types/twitter-text": "^3.1.10",
    "angular-csv-ext": "^1.0.5",
    "angular-l10n": "^16.0.0",
    "chart.js": "^4.4.2",
    "ckeditor4-angular": "^5.1.0",
    "core-js": "^3.46.0",
    "cron-parser": "^4.9.0",
    "cronstrue": "^2.50.0",
    "csv-writer": "^1.6.0",
    "dompurify": "^3.2.4",
    "flatpickr": "^4.6.13",
    "handlebars": "^4.7.8",
    "ical.js": "^1.5.0",
    "jquery": "^3.7.1",
    "jszip": "^3.10.1",
    "jwt-decode": "^4.0.0",
    "libphonenumber-js": "^1.10.61",
    "moment": "^2.29.4",
    "ng2-charts": "^8.0.0",
    "ngx-color-picker": "^20.1.1",
    "ngx-indexed-db": "^21.0.0",
    "ngx-mask": "^20.0.3",
    "ngx-papaparse": "^8.0.0",
    "ngx-quill": "^28.0.2",
    "oidc-client-ts": "^3.4.1",
    "quill": "^2.0.2",
    "quill-better-table": "^1.2.10",
    "recordrtc": "^5.6.2",
    "rrule": "^2.7.2",
    "rxjs": "^7.8.0",
    "sms-segments-calculator": "^1.2.0",
    "survey-angular-ui": "^2.3.3",
    "survey-core": "^2.3.3",
    "survey-creator-angular": "^2.3.3",
    "survey-creator-core": "^2.3.3",
    "timezones-ical-library": "^1.8.2",
    "ts-helpers": "^1.1.2",
    "tslib": "^2.0.0",
    "twitter-text": "^3.1.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "20.7.0",
    "@angular-eslint/eslint-plugin": "20.7.0",
    "@angular-eslint/eslint-plugin-template": "^20.7.0",
    "@angular-eslint/schematics": "20.7.0",
    "@angular-eslint/template-parser": "20.7.0",
    "@angular-eslint/utils": "^20.7.0",
    "@angular/build": "^20.3.13",
    "@angular/cli": "^20.3.13",
    "@angular/compiler-cli": "^20.3.15",
    "@angular/language-service": "^20.3.15",
    "@angular/localize": "^20.3.15",
    "@cypress/schematic": "^2.5.0",
    "@openapitools/openapi-generator-cli": "^2.13.4",
    "@schematics/angular": "^20.3.13",
    "@types/ckeditor": "^4.9.10",
    "@types/d3-shape": "^3.1.7",
    "@types/estree": "^1.0.5",
    "@types/geojson": "^7946.0.14",
    "@types/google.maps": "^3.55.7",
    "@types/jasmine": "^5.1.4",
    "@types/jquery": "^3.5.30",
    "@types/new-relic-browser": "^1.230.4",
    "@types/node": "^20.12.7",
    "@types/quill": "^2.0.14",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "cypress": "^13.8.1",
    "eslint": "^8.57.0",
    "eslint-plugin-custom-accessibility": "file:./eslint-plugin-custom-accessibility",
    "eslint-plugin-jasmine": "^4.2.0",
    "eslint-plugin-sonarjs": "^0.25.1",
    "eslint-plugin-strict-null-checks": "^0.1.2",
    "jasmine-core": "^5.1.2",
    "karma": "^6.4.3",
    "karma-brief-reporter": "^0.2.2",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "prettier": "^3.3.3",
    "ts-node": "^10.9.1",
    "typescript": "^5.9.3",
    "typescript-strict-plugin": "^2.4.4"
  },
  "optionalDependencies": {
    "fsevents": "^2.3.2"
  },
  "browser": {
    "fs": false
  }
}
